import * as React from "react";
import type { SVGProps } from "react";
const SvgWaterCooker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 3.997A1.003 1.003 0 0 0 22 3h-3.14c-.45-1.72-2-3-3.86-3H9C7.11 0 5.53 1.32 5.11 3.09 2.78 3.51 1 5.55 1 8v2c0 .55.45 1 1 1s1-.45 1-1V8c0-1.3.84-2.4 2-2.82v1.66c-.32 1.02-2 6.86-2 16.15 0 .55.45 1 1 1h16c.55 0 1-.45 1-1 0-7.49-1.09-12.74-1.69-15.03 2.058-.16 3.687-1.866 3.69-3.963M7 5h10v1H7zm-.25 3h10.5c.4 1.47 1.29 5.27 1.62 10.78q-.03-.03-.064-.057-.049-.04-.086-.083c-.65-.91-1.7-1.42-2.79-1.42-1.11-.02-2.18.51-2.83 1.42-.27.38-.71.56-1.21.58-.47-.02-.9-.21-1.17-.58a3.44 3.44 0 0 0-2.79-1.42 3.39 3.39 0 0 0-2.79 1.37C5.48 13.17 6.35 9.45 6.75 8M9 2h6c.74 0 1.39.4 1.73 1H7.27c.35-.6.99-1 1.73-1M5.013 21.67q.006-.321.017-.63c.68-.22 1.27-.64 1.69-1.23.27-.38.7-.61 1.21-.58.45-.02.9.21 1.17.58.64.89 1.67 1.42 2.72 1.42h.14c1.09 0 2.12-.53 2.76-1.42.27-.38.71-.61 1.21-.58.44-.02.9.21 1.17.58.46.64 1.12 1.08 1.87 1.29q.001.223.01.447.009.23.01.463H5.01V22q0-.166.003-.33M19 6V5h1.73c-.35.6-.99 1-1.73 1m-5.71 9.7c.2.2.45.29.71.29q.185 0 .359-.066.192-.074.351-.224a.996.996 0 0 0 0-1.41.7.7 0 0 1 0-1 2.704 2.704 0 0 0 0-3.83.996.996 0 1 0-1.41 1.41.7.7 0 0 1 0 1 2.704 2.704 0 0 0 0 3.83zm-3.29.29c-.26 0-.51-.09-.71-.29h.01a2.704 2.704 0 0 1 0-3.83.7.7 0 0 0 0-1 .996.996 0 1 1 1.41-1.41 2.704 2.704 0 0 1 0 3.83.7.7 0 0 0 0 1c.39.39.39 1.02 0 1.41-.2.19-.45.29-.71.29"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWaterCooker;
